(function (Drupal, once) {
  Drupal.behaviors.cleverreachNewsletterValidation = {
    attach: function (context, settings) {

      const CLEVERREACH_URL = 'https://mailings.swro.de/f/433079-419804/wcs/';

      once('newsletterFormBehavior', '.c-form--newsletter', context).forEach(function (form) {
        const emailField = form.querySelector('input[name="email"]');
        const submitButton = form.querySelector('button[type="submit"], input[type="submit"]');

        if (!emailField || !submitButton) {
          return;
        }

        let errorBox = form.querySelector('#newsletter-error');
        if (!errorBox) {
          errorBox = document.createElement('div');
          errorBox.id = 'newsletter-error';
          errorBox.className = 'messages messages--error';
          errorBox.role = 'alert';
          errorBox.style.display = 'none';
          form.appendChild(errorBox);
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        let observer = null;

        const updateButtonState = () => {
          const email = emailField.value.trim();
          const isValid = email !== '' && emailField.checkValidity() && emailRegex.test(email);

          submitButton.disabled = !isValid;
          submitButton.classList.toggle('disabled', !isValid);
        };

        const showError = (msg) => {
          errorBox.textContent = msg;
          errorBox.style.display = 'block';
          emailField.classList.add('is-invalid');
          emailField.focus();
        };

        const hideError = () => {
          errorBox.style.display = 'none';
          emailField.classList.remove('is-invalid');
        };

        emailField.addEventListener('input', () => {
          hideError();
          updateButtonState();
        });

        emailField.addEventListener('blur', () => {
          const email = emailField.value.trim();
          if (email && (!emailField.checkValidity() || !emailRegex.test(email))) {
            showError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
          }
        });

        emailField.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' && submitButton.disabled) {
            e.preventDefault();
          }
        });

        observer = new MutationObserver(() => {
          requestAnimationFrame(() => {
            updateButtonState();
          });
        });

        observer.observe(submitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'class']
        });

        const handleSubmit = (e) => {
          e.preventDefault();

          hideError();

          const email = emailField.value.trim();

          if (!email) {
            showError('Bitte geben Sie Ihre E-Mail-Adresse ein.');
            return;
          }

          if (!emailField.checkValidity() || !emailRegex.test(email)) {
            showError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
            return;
          }

          observer.disconnect();
          form.removeEventListener('submit', handleSubmit);

          form.action = CLEVERREACH_URL;
          form.submit();
        };

        form.addEventListener('submit', handleSubmit);

        updateButtonState();
      });
    }
  };
})(Drupal, once);